// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ae5pF","icon":"styles_icon__1Yseu"};